<template>
<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"  :page-size="pageSize" layout="total,prev, pager, next, jumper" :total="total" style="float:right;" >
	</el-pagination>
</template>

<script>
	export default {
		name: 'pagination',
		props: {
			pageSize: {
		            type: Number,
		            default: 0
		        },
		    total: {
		            type: Number,
		            default: 1
		    }
		},
		data() {
			return {
			
			}
		},
		methods: {
			handleSizeChange(val){
				this.$emit('handleSizeChangeSub', val);
			},
			handleCurrentChange(val){
				this.$emit('handleCurrentChangeSub', val);
			}
		},
		created() {
			console.log(this.pageSize)
		}
	}
</script>

<style>
</style>
